export const styles = {
  heading: {
    padding: `10px`,
    backgroundColor: `darkturquoise`,
    color: `white`,
    fontFamily: '"Nunito", sans-serif',
    fontWeight: 300
  },
  main: {
    display: `flex`,
    justifyContent: `space-between`,
    fontFamily: '"Nunito", sans-serif'
  },
  footer: {
    marginTop: `15px`,
    backgroundColor: `azure`,
    fontFamily: '"Nunito", sans-serif'
  }
}



// WEBPACK FOOTER //
// ./src/pagesStyles/index.Style.js